import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PatientsRoutingModule } from './patients-routing.module';
import { PatientsComponent } from './patients.component';
import { PSubscriptionComponent } from './subscription/p-subscription/p-subscription.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { MediConsultComponent } from './Telemedicine-Section/medi-consultant/medi-consult.component';
import { AmbulanceComponent } from './Ambulance-Section/ambulance/ambulance.component';
import { HistoryComponent } from './Ambulance-Section/history/history.component';
import { HistoryMediConsultComponent } from './Telemedicine-Section/history-medi-consult/history-medi-consult.component';
import { AgGridModule } from 'ag-grid-angular';
import { BillingComponent } from './subscription/billing/billing.component';
import { AmbulanceBookComponent } from './ambulance-book/ambulance-book.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BookTeleMedicineComponent } from './book-tele-medicine/book-tele-medicine.component';
import { MediConsultDetailComponent } from './Telemedicine-Section/medi-consultant-detail/medi-consult-detail.component';
import { SharedModule } from '../../shared/shared.module';
import { StickybarComponent } from '../../components/stickybar/stickybar';
import { SubHeaderComponent } from '../../components/sub-header/sub-header';
import { AgGridTableComponent } from '../../components/ag-grid-table/ag-grid-table';
import { NgSelectModule } from '@ng-select/ng-select';
import { AddAlternateNumberComponent } from '../../shared/add-alternate-number/add-alternate-number.component';

@NgModule({
  declarations: [
    PatientsComponent,
    PSubscriptionComponent,
    MediConsultComponent,
    MediConsultDetailComponent,
    HistoryMediConsultComponent,
    AmbulanceComponent,
    HistoryComponent,
    BillingComponent,
    AmbulanceBookComponent,
    BookTeleMedicineComponent,
  ],
  imports: [
    CommonModule,
    StickybarComponent,
    SubHeaderComponent,
    AgGridTableComponent,
    PatientsRoutingModule,
    NgxSpinnerModule,
    FormsModule,
    SharedModule,
    AgGridModule,
    NgxIntlTelInputModule,
    NgSelectModule,
    AddAlternateNumberComponent,
  ],
  exports: [AmbulanceComponent],
})
export class PatientsModule {}
